import toggleMenu from './togglemenu.js';

const jQ = jQuery.noConflict();

class smoothScrollOnLinks{

	constructor(selector){
		this.sel = selector;
		this.headerChecker = ".header-checker";
		this.mainMenu = ".main-menu";
		this.headerMain = ".header-main";
		this.body = 'body';
	}

	smoothScroll(e){

		if (jQ(this.body).hasClass('home')) {
			e.preventDefault();
			const headerHeight = window.innerWidth > 768 ? 105 : 55;
			const link = jQ(e.currentTarget).attr("href");
			const target = link.substr(link.lastIndexOf('/') + 1);
			const targetOffsetTop = jQ(target).offset().top - headerHeight;
	
			if(jQ(this.headerMain).hasClass("menu-open")){
				toggleMenu.closeMenu();
			}
	
			jQ('html, body').animate({
					scrollTop: targetOffsetTop,
				}, 300, function(){
			});
		}
	}

	init(){

		jQ(this.sel).on("click", (e) => {
			this.smoothScroll(e);
		});
	}

}
const smScrollOnLinks = new smoothScrollOnLinks('.main-menu .menu-items a');

export default smScrollOnLinks;



// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/smoothscrollonlinks.js